module.exports = __webpack_public_path__ + "static/media/terraspeak-2.c2786316.jpg";